import { render, staticRenderFns } from "./autocomplete-suggestions.vue?vue&type=template&id=f7c468f4"
import script from "./autocomplete-suggestions.vue?vue&type=script&lang=js"
export * from "./autocomplete-suggestions.vue?vue&type=script&lang=js"
import style0 from "./autocomplete-suggestions.vue?vue&type=style&index=0&id=f7c468f4&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports